import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxMaterialModule } from '@impesa/ngx-core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-kyc-alert-reg',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxMaterialModule, TranslateModule],
  templateUrl: './kyc-alert-reg.component.html',
  styleUrls: ['./kyc-alert-reg.component.scss'],
})
export class KycAlertREGComponent {}
